<template>
  <div class="ChukuReceipts app-container">
    <div ref="searchBox">
      <div class="formBox margbot">
        <el-form ref="searchForm" :inline="true" class="demo-form-inline"  label-width="90px" size="mini">
          <div class="formItemBox">
          <el-form-item label="出库单号:">
            <el-input class="ipt"  v-model="searchForm.outstockNo" maxlength="50"
              placeholder="请输入出库单号" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="出库日期:">
            <div style="display: flex;">
            <el-date-picker v-model="searchForm.outstockDateStart" size="mini" kehu="date"
              placeholder="选择出库开始日期" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            -
            <el-date-picker v-model="searchForm.outstockDateEnd" size="mini" kehu="date"
              placeholder="选择出库结束日期" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="一级货主:">
            <el-select v-model="searchForm.primaryCustomerTaxId" size="mini" filterable clearable placeholder="请选择一级货主">
              <el-option v-for="(item,index) in OwnerData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级货主:">
            <el-select v-model="searchForm.customerTaxId" size="mini" filterable clearable placeholder="请选择二级货主">
              <el-option v-for="(item,index) in OwnerData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="货权方:">
            <el-select v-model="searchForm.ownerCustomerTaxId" size="mini" filterable clearable placeholder="请选择货权方">
              <el-option
                v-for="(item,index) in HQData"
                :key="index"
                :label="item.custerName"
                :value="item.taxpayerNumber"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="车牌号:">
            <el-input class="ipt" v-model="searchForm.outstockPlateNumber" maxlength="50"
              placeholder="请输入车牌号" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="提货单号:">
            <el-input class="ipt" v-model="searchForm.billNo" maxlength="50" placeholder="请输入提货单号"
              size="mini"></el-input>
          </el-form-item>
          <el-form-item label="客户单号:">
            <el-input class="ipt" v-model="searchForm.outBillNo" maxlength="50"
              placeholder="请输入客户单号" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="货物类型:">
            <el-select v-model="searchForm.productType" clearable placeholder="请选择货物类型" filterable size="mini">
              <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productName"
                :value="item.productType">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="提货客户:">
            <el-select v-model="searchForm.pickupCustomerTaxId" size="mini" filterable clearable placeholder="请选择提货客户">
              <el-option
                v-for="(item,index) in OwnerData"
                :key="index"
                :label="item.custerName"
                :value="item.taxpayerNumber"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
         </div>
          <el-form-item>
            <el-button type="primary" size="mini" @click="chaxun" btnCode="00cP007B001" v-if="btnFlg[0]">查询</el-button>
            <el-button type="primary" size="mini" @click="chongzhi" btnCode="00cP007B002" v-if="btnFlg[1]">重置
            </el-button>
            <el-button type="primary" size="mini" @click="printChukudan" btnCode="00cP007B003" v-if="btnFlg[2]">打印出库单
            </el-button>
            <!-- <el-button type="primary" size="mini" @click="editXieCheCost"  btnCode="003P01EB005">修改装车费</el-button> -->
            <el-button type="primary" size="mini" @click="daochu" btnCode="00cP007B004" v-if="btnFlg[3]">导出</el-button>
          </el-form-item>
          <el-form-item>
             <span style="margin-right:20px;">总吨数：<span
            style="color: red">{{Number(allWeightMaster).toFixed(4) }}</span>吨</span>
             <span>总件数：<span style="color: red">{{allNumberMaster }}</span>件</span>
          </el-form-item>
        </el-form>

      </div>
    </div>
    <div :style="{height:h}">
      <el-table size="mini" height="100%" ref="table" :data="tableData" border center bordersize="mini"
        style="width:100%" class="tableComent" :header-cell-style="{background:'#F5F5F5',color:'black'}" highlight-current-row
        @row-click="dianjixuanzhong" @selection-change="selectGoods">
        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="lookGoods(scope.row)" size="mini" v-show="scope.row.path">提货函</el-button>
            <el-button type="text" @click="lookMessage(scope.row)" size="mini">人车信息</el-button>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="出库单号" prop="outstockNo" width="250" align="center">
        </el-table-column>
        <el-table-column label="出库人" prop="outstockUserName" width="130" align="center"></el-table-column>
        <el-table-column label="出库日期" prop="outstockDate" width="180" align="center" :formatter="dateTimeFormat">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="一级货主" prop="primaryCustomerName" width="230"
          align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="二级货主" prop="customerName" width="230" align="center">
        </el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" label="提货客户" prop="pickupCustomerName" width="250px" align="center"></el-table-column> -->
        <el-table-column label="车牌号" prop="outstockPlateNumber" width="150" align="center"></el-table-column>
        <el-table-column label="司机" prop="driverName" width="150" align="center"></el-table-column>
        <el-table-column label="司机电话" prop="telephone" width="150" align="center"></el-table-column>
        <el-table-column label="身份证号" prop="idNumber" width="200" align="center"></el-table-column>
        <el-table-column label="数据来源" prop="sourceName" width="100" align="center"></el-table-column>
        <el-table-column label="提货单号" prop="billNo" width="250" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="miniBillNo" label="预提单号" align="center" width="220">
        </el-table-column>
        <el-table-column label="客户单号" prop="outBillNo" width="150" align="center"></el-table-column>
        <el-table-column label="创建人" prop="createUser" width="130" align="center"></el-table-column>
        <el-table-column label="创建时间" prop="createTime" width="200" align="center" :formatter="dateTimeFormat">
        </el-table-column>
        <el-table-column prop="pickupCustomerName" label="提货客户" width="180px"></el-table-column>

        <el-table-column label="备注" prop="remark" width="200" align="center"></el-table-column>
        <el-table-column prop="driverConfirmDate" label="司机确认时间" width="180" :formatter="dateTimeFormat"
          :show-overflow-tooltip="true"></el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div class="pags" style="text-align: right">
      <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo"
        :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
    </div>
    <!--出库单详情-->
    <div>
      <div class="detailsTitle">
        <h4>货物明细</h4>
      </div>
      <div ref="searchBox2" style="margin-top: 5px;margin-left:10px;">
        <span>
          总吨数:
          <span style="color: red">{{ allWeight }}</span> &nbsp;吨
        </span>
        <span style="margin-left: 20px">
          件数:
          <span style="color: red">{{ allNumber }}</span> &nbsp;件
        </span>
      </div>
      <!-- <p class="detailsTitle-sum"><span>总吨数：<span class="num">{{ allWeight }}</span>吨</span><span>总件数：<span class="num">{{allNumber}}</span>件</span></p> -->

      <!--详情表格-->
      <div class="ruKuZuoyeWarp-body-detailsTab">
        <div class="ruKuZuoyeWarp-body-table" :style="{height:detailsH}">
          <el-table height="100%" size="mini" ref="tabref" border center bordersize="mini" :data="subTableData"
            style="width:100%" highlight-current-row :header-cell-style="{background:'#F5F5F5',color:'black'}"
            @row-click="dianjixuanzhong" @select="selectXiangqingTable" @selection-change="changeFun">
            <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
            <el-table-column align="center" label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="text" @click="lookBD(scope.row)" size="mini"
                  v-if="Number(scope.row.weighingWeight / 1) > 0">磅单</el-button>
                <el-button type="text" @click="guoBangClick(scope.row)" size="mini">过磅记录</el-button>
              </template>
            </el-table-column>
            <el-table-column label="货物类型" prop="productTypeName" width="110px"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" label="产地" prop="placeOfOrigin" width="120" align="center">
            </el-table-column>
            <el-table-column label="材质" prop="model" width="130" align="center"></el-table-column>
            <el-table-column label="规格" prop="specification" width="150" align="center"></el-table-column>
            <el-table-column prop="vehicleNumber" label="车船号" width="120"></el-table-column>
            <el-table-column label="仓位" prop="warehouseName" width="90" align="center"></el-table-column>
            <el-table-column label="件数" prop="number" width="90" align="center"></el-table-column>
            <el-table-column label="总重量（吨）" prop="allWeight" width="130" align="center"></el-table-column>
            <el-table-column label="理重（吨）" prop="weight" width="100" align="center"></el-table-column>
            <el-table-column prop="shipForecastNo" label="预报编号" width="300"></el-table-column>
            <el-table-column label="过磅净重（吨）" prop="weighingWeight" align="center" width="130"></el-table-column>
            <el-table-column label="过磅净重时间" prop="weighingDate" width="180" align="center" :formatter="dateTimeFormat">
            </el-table-column>
          </el-table>
          <!-- 分页-->
          <div class="pags" style="text-align: right;">
            <el-pagination background @current-change="handleCurrentChangeXQ" :current-page="pageInfoXQ.pageNo"
              :page-size="pageInfoXQ.pageSize" :page-sizes="[10,20,30,40,50]"
              layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeXQ" :total="totalXQ">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- <el-dialog title="查看备注" :visible.sync="dialogBeizhuVisible" width="35%">
      <div v-if="!lookApproverReject">{{beizhu}}</div>
      <span v-if="lookApproverReject">暂无备注</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogBeizhuVisible = false">关 闭</el-button>
      </span>
    </el-dialog> -->

    <!-- 人车信息 -->
    <rcDialog v-if="RCVisible" :RCVisible.sync='RCVisible' :identityNo="identityNo" :vhcNo="vhcNo"
      :driverName="driverName" :telephone="telephone"></rcDialog>
    <!-- 查看磅单 -->
    <bdDialog v-if="BDVisible" :BDVisible.sync='BDVisible' :outstockSummaryId="outstockSummaryId"></bdDialog>
    <!-- 过磅记录 -->
    <gBJiLu-dialog v-if="guoBangVisible" :guoBangVisible.sync='guoBangVisible' :outstockSummaryId="outstockSummaryId">
    </gBJiLu-dialog>
  </div>
</template>

<script>
import {
  getRelationCustomer,
  zidian,
  getVirtualBalingList,
  getOutstockMasterListJanFa,
  JfgetOutstockSummaryListJanFa,
  getSBillFileUrl
} from '@/api/wms-stock'
import {
  getBtn
} from '@/utils/getButton'
import DonMessage from '@/utils/message'
import {
  exportExcel
} from '@/utils/fileDown.js'
import {
  dateTimeFormat
} from '@/utils/util'
import rcDialog from '../../yycRuKu/yycChuanYun/dialog/RCdialog.vue'
import bdDialog from '../../yycRuKu/yycChuanYun/dialog/BDImg.vue'
import gBJiLuDialog from '../gBJiLuDialog.vue'
export default {
  name: 'ChukuReceipts',
  components: {
    rcDialog,
    bdDialog,
    gBJiLuDialog
  },
  data () {
    return {
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      searchForm: {
        outstockNo: '',
        outstockDateStart: '',
        outstockDateEnd: '',
        // ownerCustomerTaxId: '',
        primaryCustomerTaxId: '',
        customerTaxId: '',
        billNo: '',
        outstockPlateNumber: '',
        // productType: '',
        steelMillName: '',
        outBillNo: '',
        pickupCustomerTaxId: ''
        // outstockDateEnd: ''
      },
      productTypeData: [],
      OwnerData: [],
      // HQData: [], // 货权方
      HWData: [],
      h: '500px',
      tableData: [],
      subTableData: [],
      btnFlg: [],
      btnIdArr: [
        '00cP007B001',
        '00cP007B002',
        '00cP007B003',
        '00cP007B004'
      ],
      totalXQ: 0,
      total: 0,
      detailsH: '200px',
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      pageInfoXQ: {
        pageNo: 1,
        pageSize: 20
      },
      xuanzhongArr: null,
      xuanzhongArrdown: null,
      allNumber: 0,
      allWeight: 0,

      allWeightMaster: 0,
      allNumberMaster: 0,
      beizhu: '',
      // dialogBeizhuVisible: false,
      // lookApproverReject: false,
      steelMillNameData: [],
      RCVisible: false,
      vhcNo: '',
      identityNo: '',
      telephone: '',
      driverName: '',
      BDVisible: false,
      outstockSummaryId: '',
      guoBangVisible: false
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/yycCKDanJu')
    // console.log(this.btnFlg)
    this.getVirtualBalingLists()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.chaxun()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let h2 = this.$refs.searchBox2.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = 0.6 * pH - h - 175 + 'px'
    this.detailsH = 0.4 * pH - h2 - 80 + 'px'
    this.zidians()
    this.getRelationCustomerS()
    this.getOutstockMasterListJanFas()
    // this.detailsH = 0.4 * pH - h2 - 60 + 'px'
  },
  methods: {

    // 点击过磅记录
    guoBangClick (row) {
      this.guoBangVisible = true
      this.outstockSummaryId = row.outstockSummaryId
    },
    // 人车信息
    lookMessage (row) {
      this.RCVisible = true
      this.identityNo = row.idNumber
      this.vhcNo = row.outstockPlateNumber
      this.telephone = row.telephone
      this.driverName = row.driverName
    },
    // 提货函
    lookGoods (row) {
      if (row.path) {
        let formData = new FormData()
        formData.append('url', row.path)
        getSBillFileUrl(formData).then(res => {
          this.$router.push({
            name: 'Pdf',
            query: {
              path: res
            }
          })
        })
      }
    },
    // 磅单
    lookBD (row) {
      this.BDVisible = true
      this.outstockSummaryId = row.outstockSummaryId
    },
    chakanbeizhu (row) {
      this.dialogBeizhuVisible = true
      this.beizhu = row.remark
    },
    daochu () {
      exportExcel(
        this.global.wmsStockName + '/tEmptyForJanFa/exportEmptyOutstockMasterListJanFa', {
          ...this.searchForm,
          outstockStatus: '1'
        },
        '出库单据表'
      )
    },
    chaxun () {
      this.getOutstockMasterListJanFas()
    },
    chongzhi () {
      this.searchForm.outstockNo = ''
      this.searchForm.outstockDateStart = ''
      this.searchForm.outstockDateEnd = ''
      this.searchForm.primaryCustomerTaxId = ''
      this.searchForm.customerTaxId = ''
      this.searchForm.billNo = ''
      this.searchForm.outstockPlateNumber = ''
      this.searchForm.pickupCustomerTaxId = ''
      this.searchForm.steelMillName = ''
      this.searchForm.outBillNo = ''
      this.searchForm.productType = ''

      this.getOutstockMasterListJanFas()
    },
    printChukudan () {
      if (this.tableData.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        })
        return
      }
      this.$router.push({ // 核心语句
        path: '/yycChuKuDan', // 跳转的路径
        query: {
          // 路由传参时push和query搭配使用 ，作用时传递参数
          id: this.xuanzhongArr.outstockId
        }
      })
    },
    printChukudan1 () {
      if (this.tableData.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        })
        return
      }
      this.$router.push({ // 核心语句
        path: '/chukuDanPrint1', // 跳转的路径
        query: {
          // 路由传参时push和query搭配使用 ，作用时传递参数
          id: this.xuanzhongArr.outstockId
        }
      })
    },
    // 点击
    dianjixuanzhong (row) {
      // console.log(row)
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
      // this.getOutstockMasterListJanFas()

      this.JfgetOutstockSummaryListJanFas()
    },
    dianjixuanzhongdown (row) {
      this.xuanzhongArrdown = {}
      this.xuanzhongArrdown = row
      // this.JfgetOutstockSummaryListJanFas()
    },
    selectGoods () {},
    dianjiXiangqingtable () {},
    selectXiangqingTable () {},
    changeFun () {},
    // 分页
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.getOutstockMasterListJanFas()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.getOutstockMasterListJanFas()
    },
    handleCurrentChangeXQ (val) {
      this.pageInfoXQ.pageNo = val
      this.JfgetOutstockSummaryListJanFas()
    },
    handleSizeChangeXQ (val) {
      this.pageInfoXQ.pageSize = val
      this.JfgetOutstockSummaryListJanFas()
    },
    // 出库主列表
    getOutstockMasterListJanFas () {
      getOutstockMasterListJanFa({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        outstockStatus: 1,
        outstockNo: this.searchForm.outstockNo,
        outstockDateStart: this.searchForm.outstockDateStart,
        outstockDateEnd: this.searchForm.outstockDateEnd,
        primaryCustomerTaxId: this.searchForm.primaryCustomerTaxId,
        customerTaxId: this.searchForm.customerTaxId,
        billNo: this.searchForm.billNo,
        productType: this.searchForm.productType,

        // productType: this.searchForm.productType,
        outstockPlateNumber: this.searchForm.outstockPlateNumber,
        steelMillName: this.searchForm.steelMillName,
        // ownerCustomerTaxId: this.searchForm.ownerCustomerTaxId, searchForm.productType
        outBillNo: this.searchForm.outBillNo,
        pickupCustomerTaxId: this.searchForm.pickupCustomerTaxId,
        ...this.pageInfo
      })
        .then(res => {
          console.log(res)
          this.tableData = res.pageInfo.list
          this.allWeightMaster = res.all.allWeight
          this.allNumberMaster = res.all.allNumber
          // this.allLoadingFee = res.allLoadingFee
          if (res.pageInfo.list.length > 0) {
            this.xuanzhongArr = res.pageInfo.list[0]
            this.$nextTick(() => {
              if (this.tableData.length > 0) this.$refs.table.setCurrentRow(res.pageInfo.list[0])
            })
            this.JfgetOutstockSummaryListJanFas()
          } else {
            this.subTableData = []
            this.allNumber = 0
            this.allWeight = 0
            this.totalXQ = 0
          }
          this.total = res.pageInfo.total
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物详情
    JfgetOutstockSummaryListJanFas () {
      JfgetOutstockSummaryListJanFa({
        outstockId: this.xuanzhongArr.outstockId,
        ...this.pageInfoXQ
      })
        .then(res => {
          console.log(res)
          this.subTableData = res.pageInfo.list
          if (res.pageInfo.list.length > 0) this.xuanzhongArrdown = res.pageInfo.list[0]
          this.$nextTick(() => {
            this.$refs.tabref.setCurrentRow(res.pageInfo.list[0])
          })
          this.totalXQ = res.pageInfo.total
          this.allNumber = res.all.allNumber
          this.allWeight = res.all.allWeight
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          // console.log(res)
          this.OwnerData = res
          this.HQData = JSON.parse(JSON.stringify(res))
          this.HQData.unshift({
            'custerName': '无货权方',
            'taxpayerNumber': '-1'
          })
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 货物类型
    zidians () {
      zidian({
        groupNo: 'thread_product_type'
      })
        .then((res) => {
          // console.log(res)
          this.HWData = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 下拉框
    getVirtualBalingLists () {
      getVirtualBalingList()
        .then(res => {
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
          console.log(this.productTypeData, 'this.productTypeData')
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    }
  }

}

</script>

<style lang="less" scoped >
  .controlCargos-search {
    .el-form-item {
      margin-left: 10px;
      margin-bottom: 0px;
    }
  }

  .ChukuReceipts {
    // padding-left:5px;
  }

  .detailsTitle-sum {
    padding-left: 20px;

    .num {
      color: rgb(224, 0, 32)
    }
  }

   .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }

</style>
